module.exports = __webpack_public_path__ + "static/media/icon_mapa_red.c82c3b69.svg";